import { types } from 'mobx-state-tree';

import APPROVAL_LIKELIHOOD_SCORES from '../definitions/ApprovalLikelihoodScores';

/**
 * Model for cards that are displayed in the results page for marketing events and analytics
 */
const DisplayedCard = types
    .model('DisplayedCard', {
        // TODO: Remove integer once legacy Id migrated https://ratehub.atlassian.net/browse/CCDEP-2853
        id: types.maybe(types.union(types.string, types.integer)),
        name: types.maybe(types.string),
        cardImageURL: types.maybe(types.string),
        approvalLikelihoodScore: types.maybe(types.enumeration(Object.values(APPROVAL_LIKELIHOOD_SCORES))),
        applyRedirectURL: types.maybe(types.string),
    });

export default DisplayedCard;
